import AbstractDevice from '../all/AbstractDevice';
import KeplerId from "./Id";
import AAFBitmovinPlayer from '../all/bitmovin/AAFBitmovinPlayer';
import KeplerPlayerUtil from "./PlayerUtil";
import KeplerConfig from "./config";
import KeplerKeys from "./Keys";
import KeplerNetworkStatus from "./NetworkStatus";
import KepplerSystem from "./System";


class KeplerDevice extends AbstractDevice {
  constructor () {
    super(
      "kepler",
      new KeplerId(),
      new AAFBitmovinPlayer(),
      new KeplerPlayerUtil(),
      KeplerConfig,
      new KeplerKeys(),
      new KeplerNetworkStatus(),
      new KepplerSystem()
    );
  }
}

export default KeplerDevice;



// WEBPACK FOOTER //
// ./src/devices/kepler/Device.js